import { HalLink } from './hal-link.mode';

export interface HalObjectLinks {
  self: HalLink;
}
